import React from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInside } from './components/LookInside';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { MoreResults } from './components/MoreResults';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { Testimonials } from './components/Testimonials';
import { UrgencySection } from './components/UrgencySection';
export function App() {
  return <div className="min-h-screen w-full overflow-hidden bg-navy font-sans text-ink antialiased" data-id="element-0" data-mp="3ihv048vgebg8">
      <MetaPixel data-id="element-1" data-mp="3mjga9mglsbmq" />
      <main data-id="element-2" data-mp="3rc9e8848zfxr">
        <Hero data-id="element-3" data-mp="3rcj31sdk3h1v" />
        <Testimonials data-id="element-4" data-mp="3rbzo8kj7d8s2" />
        <LookInside data-id="element-5" data-mp="3rcsxpt9jqcdw" />
        <ProblemSection data-id="element-6" data-mp="3recedkz46pg7" />
        <SystemSection data-id="element-7" data-mp="5osn3wyp084" />
        <ModulesSection data-id="element-8" data-mp="6801qozk67w" />
        <BonusSection data-id="element-9" data-mp="5gfdawxfswe" />
        <UrgencySection data-id="element-10" data-mp="82ovg3doih9" />
        <PricingSection data-id="element-11" data-mp="2zld2jatxbhc2" />
        <MoreResults data-id="element-12" data-mp="2zm4ywnvchj3e" />
        <GuaranteeSection data-id="element-13" data-mp="2zmo5j8fjol24" />
        <FAQ data-id="element-14" data-mp="2zng2onosiqui" />
        <ClosingSection data-id="element-15" data-mp="33mf3bw3ho1g5" />
        <SummaryTable data-id="element-16" data-mp="33lx0uhq8gqzs" />
        <FinalCta data-id="element-17" data-mp="33n6yj5t6bx5w" />
      </main>
      <Footer data-id="element-18" data-mp="33oi0r16z0wuw" />
      <PurchaseNotification data-id="element-19" data-mp="38m1gk5jbhhoy" />
    </div>;
}